import { Button, Card, CardBody, CardHeader, Input } from '@nextui-org/react';
import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { PasswordInput } from '@portal/components/common/PasswordInput.ui';
import { TypographyUI } from '@portal/components/common/Typography.ui';
import { tsrestClient } from '@portal/provider/tsrest';

export const Login = () => {
  const loginMutation = tsrestClient.auth.login.useMutation({
    onSuccess: data => {
      localStorage.setItem('token', data.body.token);
      window.location.href = '/monitors';
    },
    onError: e => {
      toast(
        <>
          <TypographyUI className='font-bold'>Cannot login</TypographyUI>
          <TypographyUI className='text-ts'>error: {(e.body as any).message}</TypographyUI>
        </>,
        {
          type: 'error',
        }
      );
    },
  });

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const onLogin = () => {
    if (username === '' || password === '') return;
    loginMutation.mutate({
      body: {
        username,
        password,
      },
    });
  };

  return (
    <div className='h-[calc(100vh-200px)] flex justify-center items-center'>
      <Card className='w-[500px] p-4'>
        <CardHeader className='flex-col items-start gap-2'>
          <TypographyUI variant='h1'>Login</TypographyUI>
          <TypographyUI variant='h4'>It&apos;s Monitors Time</TypographyUI>
        </CardHeader>
        <CardBody className='gap-4'>
          <Input label='Username' variant='bordered' autoFocus onValueChange={v => setUsername(v)} />
          <PasswordInput
            label='Password'
            variant='bordered'
            onValueChange={v => setPassword(v)}
            onKeyPress={e => e.key === 'Enter' && onLogin()}
          />{' '}
          <Button
            variant='shadow'
            color='primary'
            className='h-[44px] mb-2'
            isLoading={loginMutation.isLoading}
            onPress={onLogin}
            isDisabled={username === '' || password === ''}
          >
            Login
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};
